import useSWR, { useSWRConfig } from 'swr';
import { registerService } from '@/services/api';
import { useRegistrationStore } from '@/store/pages/registrationStore/registrationStore';
import { config } from '@/config';
import { useRouter } from '@/hooks/general/useRouter/useRouter';

export const useRegistrationDetailsQuery = (
    shouldFetch = true,
    refreshInterval = 0,
    regId: string | undefined = undefined,
    shouldRetryOnError = true,
) => {
    const router = useRouter();
    const { mutate } = useSWRConfig();
    const API_URL = config.api.url.registration;
    const sessionRegId = useRegistrationStore((state) => state.registrationId);
    const registrationId = regId ?? sessionRegId;
    const SWR_KEY =
        shouldFetch && registrationId ? [`${API_URL}/registration/`, registrationId] : null;

    const { data, isLoading } = useSWR(
        SWR_KEY,
        ([, registrationId]: [_: string, registrationId: string]) => {
            return registerService.getRegistrationData(registrationId, { routerPush: router.push });
        },
        {
            revalidateOnFocus: false,
            errorRetryCount: 2,
            refreshInterval,
            shouldRetryOnError,
        },
    );

    return { data, revalidate: () => mutate(SWR_KEY), isLoading };
};
